var giphy_viewer_default = {
  "giphyWrapper": "AIFfM",
  "giphy_player": "zMHtl",
  "playIcon": "LLzqS",
  "gifRatio": "_-2u5h"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
